import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';

@Component({
  selector: 'ume-new-user-signup-dialog',
  templateUrl: './new-user-signup-dialog.component.html',
  styleUrls: ['./new-user-signup-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIcon, MatStepperModule],
})
export class NewUserSignupDialogComponent {
  public contentHeight = 520;
}
